export const MAX_NUMBER_OF_PARAMETERS = 20;
export const TIMING_TOKEN = "TIMING_PARAMETER";
export const CUSTOM_PARAMETER_TOKEN = "CUSTOM_PARAMETER";
export const PETE_PARAMETER_LENGTH_LIMIT = 255;
